module.exports = __webpack_public_path__ + "static/media/photo226.00b295b3.jpg";